import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../components/dashboard/Header';
import { NavigationTabs } from '../components/dashboard/NavigationTabs';
import { DashboardData } from '../types';
import { adminAPI } from '../services/api/adminAPI';

export const DashboardLayout: React.FC = () => {
	const [dashboardData, setDashboardData] = useState<DashboardData | null>(null);
	const [refreshKey, setRefreshKey] = useState(0);
	const [isRefreshing, setIsRefreshing] = useState(false);

	const loadDashboardData = async () => {
		try {
			const data = await adminAPI.getDashboard();
			setDashboardData(data);
		} catch (error) {
			console.error('Failed to load dashboard data:', error);
		}
	};

	const handleRefresh = async () => {
		setIsRefreshing(true);
		setRefreshKey((prev) => prev + 1);
		await loadDashboardData();
		setIsRefreshing(false);
	};

	useEffect(() => {
		loadDashboardData();
	}, []);

	return (
		<div className="min-h-screen bg-gray-50">
			<Header onRefresh={handleRefresh} isRefreshing={isRefreshing} />
			<NavigationTabs />

			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
				<Outlet context={{ dashboardData, refreshKey }} />{' '}
			</div>
		</div>
	);
};
